import { useCallback, useMemo } from 'react';

// Components
import {
  Button,
  OutlinedSelect,
  OutlinedSelectOptionType,
  SelectOptionType,
} from '@octano/global-ui';
import { Col, Row } from 'reactstrap';

// Hooks
import { useForm } from 'react-hook-form';

// I18n
import { useTranslation } from 'react-i18next';
import { SectionFilters as SectionFiltersType } from '../type';
import { useSectionsLoader } from './Loaders/SubjectLoader';
import { useSubjectFiltersLoader } from './Loaders/SubjectFiltersLoader';

// Types
const keyPrefix = 'common.terms';

export type FilterFields = {
  careerId: SelectOptionType | null;
};

export type FilterFieldsSubmit = {
  careerId: { value: string };
};

// Render
function SectionFilters() {
  const { t } = useTranslation('translation', { keyPrefix });
  const { data } = useSubjectFiltersLoader();
  const { updateQuery, query } = useSectionsLoader();
  const { control, handleSubmit, reset } = useForm<FilterFields>({
    defaultValues: {
      careerId: null,
    },
  });

  const careers = useMemo<OutlinedSelectOptionType[]>(
    () => data?.careers.map((c: any) => ({ label: c.name, value: c.id })) || [],
    [data?.careers],
  );

  const handleClear = useCallback(() => {
    reset();

    updateQuery({
      subjectId: null,
      periodId: null,
      campusId: null,
      careerId: null,
      workingDayId: null,
      page: 1,
      itemsPerPage: 10,
    });
  }, [reset, updateQuery]);

  const handleSearch = useCallback(
    ({ careerId }: FilterFieldsSubmit) => {
      const payload: SectionFiltersType = {
        subjectId: null,
        periodId: null,
        campusId: null,
        careerId: null,
        workingDayId: null,
      };

      if (careers?.length && typeof careerId?.value === 'number') {
        payload.careerId = parseInt(`${careerId?.value}`, 10);
      }

      updateQuery({
        ...query,
        ...payload,
        page: 1,
      });
    },
    [careers?.length, query, updateQuery],
  );

  return (
    <Row className="mb-3">
      <Col xs={12} md={4}>
        <OutlinedSelect
          control={control}
          name="careerId"
          label={t('career')}
          placeholder={t('career')}
          disabled={!careers?.length}
          options={careers}
        />
      </Col>

      <Col
        className="d-flex justify-content-between pt-2 ml-auto"
        xs={12}
        md={3}
      >
        <Button
          className="my-auto"
          style={{ height: 40, minHeight: 20 }}
          text={t('search')}
          onClick={handleSubmit(handleSearch)}
          fullwidth
        />
        <Button
          className="my-auto ml-2"
          style={{ height: 40, minHeight: 20 }}
          text={t('clear')}
          outlined={true}
          onClick={handleClear}
          fullwidth
        />
      </Col>
    </Row>
  );
}

export default SectionFilters;
